import { orchestrator } from 'satcheljs';
import resetSearch from '../actions/resetSearch';
import getStore from '../store/store';
import logFailedSearchTerm from '../utils/logFailedSearchTerm';
import setQuery from '../mutators/setQuery';

export default orchestrator(resetSearch, message => {
    const { successfulSearch } = message;

    if (!successfulSearch) {
        logFailedSearchTerm(getStore().query);
    }

    setQuery('', false);
});
